module.exports = __webpack_public_path__ + "static/media/viaMEDIAlogoSANDBOX.917701ee.png";